import { InvoiceModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/invoices-service-lib/src/wrapper/outputs/invoice.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { InvoiceListNetworkCell } from './invoice-list-network.cell';
import { InvoiceListNetworkHeader } from './invoice-list-network.header';

export const InvoiceListNetworkColumn: IdentifiedColumnDef<
  InvoiceModel,
  InvoiceModel['network']
> = {
  enableSorting: false,
  header: InvoiceListNetworkHeader,
  cell: InvoiceListNetworkCell,
  meta: { maxWidth: '200px' },
};
